import { Observable } from 'rxjs/Observable';
import updateCategoryRecommendationSongs from '../actions/recommendations/updateCategoryRecommendationSongsAction';

export function handleGetCategoryRecommendationSongsFulfilled(action$, store) {
    return action$.filter(
        action => action.type === 'GET_CATEGORY_RECOMMENDATION_SONGS_FULFILLED')
        .mergeMap((action) => Observable.merge(
            Observable.of(updateCategoryRecommendationSongs(action.payload, store.getState().user.data.objectId))
        ));
}



// WEBPACK FOOTER //
// ./src/epics/getCategoryRecommendationSongsEpic.js